import ErrorPage from '@/components/errors/ErrorPage';

export default function NotFound() {
  return (
    <ErrorPage
      code="404"
      emoji="🧭"
      title="Page not found"
      description="That route does not exist in the control panel. The page may have been moved, renamed, or never existed in this build."
      details="Try using the sidebar navigation or return to the dashboard."
    />
  );
}
